export default __webpack_public_path__ + "static/media/icon-flag-poland.55e3fe6c.svg";